/** Página Buy Me a Coffee. O jogo continua gratuito. */
export const BUY_ME_A_COFFEE_URL = "https://www.buymeacoffee.com/pikitote";
